import HeaderLink from "./HeaderLink";
import React from "react";

const HeaderTextLink = props => {

	const { text, ...rest } = props;

	return (
		<HeaderLink
			{...rest}
			text={text}
		/>
	);
};

export default HeaderTextLink;